// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Roboto:300i,400,400i,500,700,900);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Font Variables */
/* Color Variables */
.multi_step_form {
  background: #f6f9fb;
  display: block;
  overflow: hidden;
}
.multi_step_form #msform {
  text-align: center;
  position: relative;
  padding-top: 50px;
  min-height: 820px;
  max-width: 810px;
  margin: 0 auto;
  background: #ffffff;
  z-index: 1;
}
.multi_step_form #msform .title {
  text-align: center;
  padding-bottom: 55px;
}
.multi_step_form #msform .title h2 {
  font: 500 24px/35px "Roboto", sans-serif;
  color: #3f4553;
  padding-bottom: 5px;
}
.multi_step_form #msform .title p {
  font: 400 16px/28px "Roboto", sans-serif;
  color: #5f6771;
}
.multi_step_form #msform fieldset {
  border: 0;
  padding: 20px 110px 0;
  position: relative;
  width: 100%;
  left: 0;
  right: 0;
}
.multi_step_form #msform fieldset:not(:first-of-type) {
  display: none;
}
.multi_step_form #msform fieldset h3 {
  font: 500 18px/35px "Roboto", sans-serif;
  color: #3f4553;
}
.multi_step_form #msform fieldset h6 {
  font: 400 15px/28px "Roboto", sans-serif;
  color: #5f6771;
  padding-bottom: 30px;
}
.multi_step_form #msform fieldset .intl-tel-input {
  display: block;
  background: transparent;
  border: none;
  box-shadow: none;
  outline: none;
}
.multi_step_form #msform fieldset .intl-tel-input .flag-container .selected-flag {
  padding: 0 20px;
  background: transparent;
  border: none;
  box-shadow: none;
  outline: none;
  width: 65px;
}
.multi_step_form #msform fieldset .form-control, .multi_step_form #msform fieldset .product_select {
  border-radius: 3px;
  border: 1px solid #d8e1e7;
  padding: 0 20px;
  height: auto;
  font: 400 15px/48px "Roboto", sans-serif;
  color: #5f6771;
  box-shadow: none;
  outline: none;
  width: 100%;
}
.multi_step_form #msform fieldset .form-control.placeholder, .multi_step_form #msform fieldset .product_select.placeholder {
  color: #5f6771;
}
.multi_step_form #msform fieldset .form-control:-moz-placeholder, .multi_step_form #msform fieldset .product_select:-moz-placeholder {
  color: #5f6771;
}
.multi_step_form #msform fieldset .form-control::-moz-placeholder, .multi_step_form #msform fieldset .product_select::-moz-placeholder {
  color: #5f6771;
}
.multi_step_form #msform fieldset .form-control::-webkit-input-placeholder, .multi_step_form #msform fieldset .product_select::-webkit-input-placeholder {
  color: #5f6771;
}
.multi_step_form #msform fieldset .form-control:hover, .multi_step_form #msform fieldset .form-control:focus, .multi_step_form #msform fieldset .product_select:hover, .multi_step_form #msform fieldset .product_select:focus {
  border-color: #5cb85c;
}
.multi_step_form #msform fieldset .form-control:focus.placeholder, .multi_step_form #msform fieldset .product_select:focus.placeholder {
  color: transparent;
}
.multi_step_form #msform fieldset .form-control:focus:-moz-placeholder, .multi_step_form #msform fieldset .product_select:focus:-moz-placeholder {
  color: transparent;
}
.multi_step_form #msform fieldset .form-control:focus::-moz-placeholder, .multi_step_form #msform fieldset .product_select:focus::-moz-placeholder {
  color: transparent;
}
.multi_step_form #msform fieldset .form-control:focus::-webkit-input-placeholder, .multi_step_form #msform fieldset .product_select:focus::-webkit-input-placeholder {
  color: transparent;
}
.multi_step_form #msform fieldset .done_text {
  padding-top: 40px;
}
.multi_step_form #msform fieldset .done_text .don_icon {
  height: 36px;
  width: 36px;
  line-height: 36px;
  font-size: 22px;
  margin-bottom: 10px;
  background: #5cb85c;
  display: inline-block;
  border-radius: 50%;
  color: #ffffff;
  text-align: center;
}
.multi_step_form #msform fieldset .done_text h6 {
  line-height: 23px;
}
.multi_step_form #msform fieldset .code_group {
  margin-bottom: 60px;
}
.multi_step_form #msform fieldset .code_group .form-control {
  border: none;
  border-bottom: 1px solid #a1a7ac;
  border-radius: 0;
  display: inline-block;
  width: 30px;
  font-size: 30px;
  color: #5f6771;
  padding: 0;
  margin-right: 7px;
  text-align: center;
  line-height: 1;
}
.multi_step_form #msform fieldset .input-group {
  padding-bottom: 40px;
}
.multi_step_form #msform fieldset .input-group .custom-file {
  width: 100%;
  height: auto;
}
.multi_step_form #msform fieldset .input-group .custom-file .custom-file-label {
  width: 168px;
  border-radius: 5px;
  cursor: pointer;
  font: 700 14px/40px "Roboto", sans-serif;
  border: 1px solid #99a2a8;
  text-align: center;
  color: #5f6771;
  transition: all 300ms linear 0s;
}
.multi_step_form #msform fieldset .input-group .custom-file .custom-file-label i {
  font-size: 20px;
  padding-right: 10px;
}
.multi_step_form #msform fieldset .input-group .custom-file .custom-file-label:hover, .multi_step_form #msform fieldset .input-group .custom-file .custom-file-label:focus {
  background: #5cb85c;
  border-color: #5cb85c;
  color: #fff;
}
.multi_step_form #msform fieldset .input-group .custom-file input {
  display: none;
}
.multi_step_form #msform #progressbar {
  margin-bottom: 30px;
  overflow: hidden;
}
.multi_step_form #msform #progressbar li {
  list-style-type: none;
  color: #99a2a8;
  font-size: 1rem;
  width: 33.3333333333%;
  float: left;
  position: relative;
}
.multi_step_form #msform #progressbar li:nth-child(2):before {
  content: "2";
}
.multi_step_form #msform #progressbar li:nth-child(3):before {
  content: "3";
}
.multi_step_form #msform #progressbar li:before {
  content: "1";
  width: 50px;
  height: 50px;
  line-height: 50px;
  display: block;
  background: #eaf0f4;
  border-radius: 50%;
  margin: 0 auto 10px auto;
}
.multi_step_form #msform #progressbar li:after {
  content: "";
  width: 100%;
  height: 10px;
  background: #eaf0f4;
  position: absolute;
  left: -50%;
  top: 21px;
  z-index: -1;
}
.multi_step_form #msform #progressbar li:last-child:after {
  width: 150%;
}
.multi_step_form #msform #progressbar li.active {
  color: #5cb85c;
}
.multi_step_form #msform #progressbar li.active:before, .multi_step_form #msform #progressbar li.active:after {
  background: #5cb85c;
  color: white;
}
.multi_step_form #msform .dropdown-menu {
  display: block;
  position: relative;
  left: 50%;
  transform: translate(-50%, 0);
}
.multi_step_form #msform .action-button {
  background: #5cb85c;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  min-width: 130px;
  font: 700 14px/40px "Roboto", sans-serif;
  border: 1px solid #5cb85c;
  margin: 0 5px;
  text-transform: uppercase;
  display: inline-block;
}
.multi_step_form #msform .action-button:hover, .multi_step_form #msform .action-button:focus {
  background: #405867;
  border-color: #405867;
}
.multi_step_form #msform .previous_button {
  background: transparent;
  color: #99a2a8;
  border-color: #99a2a8;
}
.multi_step_form #msform .previous_button:hover, .multi_step_form #msform .previous_button:focus {
  background: #405867;
  border-color: #405867;
  color: #fff;
}

/* ===== Mobile fix ===== */
@media (max-width: 768px) {
  .multi_step_form #msform {
    max-width: 100%;
    width: 100%;
    margin: 0 auto;
  }
  .multi_step_form #msform fieldset {
    padding: 20px 50px 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/consult/styles/form.scss"],"names":[],"mappings":"AAAA,mBAAA;AAGA,oBAAA;AAoBA;EACI,mBAAA;EACA,cAAA;EACA,gBAAA;AAnBJ;AAqBI;EACI,kBAAA;EACA,kBAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,UAAA;AAnBR;AAsBQ;EACI,kBAAA;EACA,oBAAA;AApBZ;AAqBY;EACI,wCAAA;EACA,cAAA;EACA,mBAAA;AAnBhB;AAqBY;EACI,wCAAA;EACA,cA3CR;AAwBR;AAwBQ;EACI,SAAA;EACA,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,OAAA;EACA,QAAA;AAtBZ;AAuBY;EACI,aAAA;AArBhB;AAuBY;EACI,wCAAA;EACA,cAAA;AArBhB;AAuBY;EACI,wCAAA;EACA,cAhER;EAiEQ,oBAAA;AArBhB;AAyBY;EACI,cAAA;EACA,uBAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;AAvBhB;AA0BoB;EACI,eAAA;EACA,uBAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;EACA,WAAA;AAxBxB;AAgCY;EACI,kBAAA;EACA,yBAAA;EACA,eAAA;EACA,YAAA;EACA,wCAAA;EACA,cAjGR;EAkGQ,gBAAA;EACA,aAAA;EACA,WAAA;AA9BhB;AA3DI;EA4FgB,cAvGZ;AAyER;AA7DI;EA2FgB,cAvGZ;AA4ER;AA/DI;EA0FgB,cAvGZ;AA+ER;AAjEI;EAyFgB,cAvGZ;AAkFR;AAwBgB;EACI,qBA7Gf;AAuFL;AA1EI;EAqGoB,kBAAA;AAxBxB;AA5EI;EAoGoB,kBAAA;AArBxB;AA9EI;EAmGoB,kBAAA;AAlBxB;AAhFI;EAkGoB,kBAAA;AAfxB;AAoBY;EACI,iBAAA;AAlBhB;AAoBgB;EACI,YAAA;EACA,WAAA;EACA,iBAAA;EACA,eAAA;EACA,mBAAA;EACA,mBAhIf;EAiIe,qBAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;AAlBpB;AAqBgB;EACI,iBAAA;AAnBpB;AAwBY;EACI,mBAAA;AAtBhB;AAwBgB;EACI,YAAA;EACA,gCAAA;EACA,gBAAA;EACA,qBAAA;EACA,WAAA;EACA,eAAA;EACA,cArJZ;EAsJY,UAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;AAtBpB;AA2BY;EACI,oBAAA;AAzBhB;AA2BgB;EACI,WAAA;EACA,YAAA;AAzBpB;AA2BoB;EACI,YAAA;EACA,kBAAA;EACA,eAAA;EACA,wCAAA;EACA,yBAAA;EACA,kBAAA;EACA,cA5KhB;EAOJ,+BAAA;AA6IJ;AA4BwB;EACI,eAAA;EACA,mBAAA;AA1B5B;AA6BwB;EACI,mBAxLvB;EAyLuB,qBAzLvB;EA0LuB,WAAA;AA3B5B;AA+BoB;EACI,aAAA;AA7BxB;AAoCQ;EACI,mBAAA;EACA,gBAAA;AAlCZ;AAoCY;EACI,qBAAA;EACA,cAAA;EACA,eAAA;EACA,qBAAA;EACA,WAAA;EACA,kBAAA;AAlChB;AAqCoB;EACI,YAAA;AAnCxB;AAwCoB;EACI,YAAA;AAtCxB;AA0CgB;EACI,YAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;EACA,wBAAA;AAxCpB;AA2CgB;EACI,WAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,WAAA;AAzCpB;AA6CoB;EACI,WAAA;AA3CxB;AA+CgB;EACI,cA3Pf;AA8ML;AA+CoB;EACI,mBA9PnB;EA+PmB,YAAA;AA7CxB;AAoDQ;EACI,cAAA;EACA,kBAAA;EACA,SAAA;EACA,6BAAA;AAlDZ;AAoDQ;EACI,mBA7QP;EA8QO,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,wCAAA;EACA,yBAAA;EACA,aAAA;EACA,yBAAA;EACA,qBAAA;AAlDZ;AAoDY;EACI,mBAzRN;EA0RM,qBA1RN;AAwOV;AAsDQ;EACI,uBAAA;EACA,cAAA;EACA,qBAAA;AApDZ;AAsDY;EACI,mBApSN;EAqSM,qBArSN;EAsSM,WAAA;AApDhB;;AA0DA,2BAAA;AACA;EAEI;IACE,eAAA;IACA,WAAA;IACA,cAAA;EAxDJ;EA2DE;IACE,oBAAA;EAzDJ;AACF","sourcesContent":["/* Font Variables */\n$roboto: 'Roboto', sans-serif;\n\n/* Color Variables */\n$bc: #5cb85c;\n$heading: #405867;\n$pfont: #5f6771;\n\n// Import Google Fonts\n@import url('https://fonts.googleapis.com/css?family=Roboto:300i,400,400i,500,700,900');\n\n// Mixins\n@mixin transition($property: all, $duration: 300ms, $animate: linear, $delay: 0s) {\n    transition: $property $duration $animate $delay;\n}\n\n@mixin placeholder {\n    &.placeholder { @content; }\n    &:-moz-placeholder { @content; }\n    &::-moz-placeholder { @content; }\n    &::-webkit-input-placeholder { @content; }\n}\n\n.multi_step_form {\n    background: #f6f9fb;\n    display: block;\n    overflow: hidden;\n    \n    #msform {\n        text-align: center;\n        position: relative;\n        padding-top: 50px;\n        min-height: 820px;\n        max-width: 810px;\n        margin: 0 auto;\n        background: #ffffff;\n        z-index: 1;\n\n        // Title section\n        .title {\n            text-align: center;\n            padding-bottom: 55px;\n            h2 {\n                font: 500 24px/35px $roboto;\n                color: #3f4553;\n                padding-bottom: 5px;\n            }\n            p {\n                font: 400 16px/28px $roboto;\n                color: $pfont;\n            }\n        }\n\n        // Fieldset styles\n        fieldset {\n            border: 0;\n            padding: 20px 110px 0;\n            position: relative;\n            width: 100%;\n            left: 0;\n            right: 0;\n            &:not(:first-of-type) {\n                display: none;\n            }\n            h3 {\n                font: 500 18px/35px $roboto;\n                color: #3f4553;\n            }\n            h6 {\n                font: 400 15px/28px $roboto;\n                color: $pfont;\n                padding-bottom: 30px;\n            }\n            \n            // Phone input styles\n            .intl-tel-input {\n                display: block;\n                background: transparent;\n                border: none;\n                box-shadow: none;\n                outline: none;\n\n                .flag-container {\n                    .selected-flag {\n                        padding: 0 20px;\n                        background: transparent;\n                        border: none;\n                        box-shadow: none;\n                        outline: none;\n                        width: 65px;\n                        \n                    }\n                }\n            }\n            \n            \n            // Form control and product select\n            .form-control, .product_select {\n                border-radius: 3px;\n                border: 1px solid #d8e1e7;\n                padding: 0 20px;\n                height: auto;\n                font: 400 15px/48px $roboto;\n                color: $pfont;\n                box-shadow: none;\n                outline: none;\n                width: 100%;\n                \n                @include placeholder {\n                    color: $pfont;\n                }\n\n                &:hover, &:focus {\n                    border-color: $bc;\n                }\n\n                &:focus {\n                    @include placeholder {\n                        color: transparent;\n                    }\n                }\n            }\n            // Done text styles\n            .done_text {\n                padding-top: 40px;\n\n                .don_icon {\n                    height: 36px;\n                    width: 36px;\n                    line-height: 36px;\n                    font-size: 22px;\n                    margin-bottom: 10px;\n                    background: $bc;\n                    display: inline-block;\n                    border-radius: 50%;\n                    color: #ffffff;\n                    text-align: center;\n                }\n\n                h6 {\n                    line-height: 23px;\n                }\n            }\n\n            // Code group\n            .code_group {\n                margin-bottom: 60px;\n\n                .form-control {\n                    border: none;\n                    border-bottom: 1px solid #a1a7ac;\n                    border-radius: 0;\n                    display: inline-block;\n                    width: 30px;\n                    font-size: 30px;\n                    color: $pfont;\n                    padding: 0;\n                    margin-right: 7px;\n                    text-align: center;\n                    line-height: 1;\n                }\n            }\n\n            // Input group\n            .input-group {\n                padding-bottom: 40px;\n\n                .custom-file {\n                    width: 100%;\n                    height: auto;\n\n                    .custom-file-label {\n                        width: 168px;\n                        border-radius: 5px;\n                        cursor: pointer;\n                        font: 700 14px/40px $roboto;\n                        border: 1px solid #99a2a8;\n                        text-align: center;\n                        color: $pfont;\n                        \n                        @include transition;\n                        \n                        i {\n                            font-size: 20px;\n                            padding-right: 10px;\n                        }\n\n                        &:hover, &:focus {\n                            background: $bc;\n                            border-color: $bc;\n                            color: #fff;\n                        }\n                    }\n\n                    input {\n                        display: none;\n                    }\n                }\n            }\n        }\n\n        // Progress bar\n        #progressbar {\n            margin-bottom: 30px;\n            overflow: hidden;\n\n            li {\n                list-style-type: none;\n                color: #99a2a8;\n                font-size: 1rem;\n                width: calc(100%/3);\n                float: left;\n                position: relative;\n\n                &:nth-child(2) {\n                    &:before {\n                        content: \"2\";\n                    }\n                }\n\n                &:nth-child(3) {\n                    &:before {\n                        content: \"3\";\n                    }\n                }\n\n                &:before {\n                    content: \"1\";\n                    width: 50px;\n                    height: 50px;\n                    line-height: 50px;\n                    display: block;\n                    background: #eaf0f4;\n                    border-radius: 50%;\n                    margin: 0 auto 10px auto;\n                }\n\n                &:after {\n                    content: '';\n                    width: 100%;\n                    height: 10px;\n                    background: #eaf0f4;\n                    position: absolute;\n                    left: -50%;\n                    top: 21px;\n                    z-index: -1;\n                }\n\n                &:last-child {\n                    &:after {\n                        width: 150%;\n                    }\n                }\n\n                &.active {\n                    color: $bc;\n\n                    &:before, &:after {\n                        background: $bc;\n                        color: white;\n                    }\n                }\n            }\n        }\n\n        // Buttons\n        .dropdown-menu {\n            display:block;\n            position: relative;\n            left: 50%;\n            transform: translate(-50%, 0);\n        }\n        .action-button {\n            background: $bc;\n            color: white;\n            border: none;\n            border-radius: 5px;\n            cursor: pointer;\n            min-width: 130px;\n            font: 700 14px/40px $roboto;\n            border: 1px solid $bc;\n            margin: 0 5px;\n            text-transform: uppercase;\n            display: inline-block;\n\n            &:hover, &:focus {\n                background: $heading;\n                border-color: $heading;\n            }\n        }\n\n        .previous_button {\n            background: transparent;\n            color: #99a2a8;\n            border-color: #99a2a8;\n\n            &:hover, &:focus {\n                background: $heading;\n                border-color: $heading;\n                color: #fff;\n            }\n        }\n    }\n    \n}\n/* ===== Mobile fix ===== */\n@media (max-width: 768px) {\n  .multi_step_form {\n    #msform {\n      max-width: 100%;\n      width: 100%;\n      margin: 0 auto;\n    }\n\n    #msform fieldset {\n      padding: 20px 50px 0;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
